var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0599 1.2677C37.8553 0.130063 35.9566 0.184313 34.819 1.38887L20 17.0795L5.18103 1.38887C4.04339 0.184313 2.14468 0.130063 0.940121 1.2677C-0.264431 2.40533 -0.318684 4.30405 0.818954 5.50861L17.819 23.5086C18.3857 24.1087 19.1746 24.4487 20 24.4487C20.8254 24.4487 21.6143 24.1087 22.181 23.5086L39.181 5.50861C40.3187 4.30405 40.2644 2.40533 39.0599 1.2677Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrow);
export default __webpack_public_path__ + "static/media/faq_arrow.17ad7c88806f8283fd9114b555904adf.svg";
export { ForwardRef as ReactComponent };